import { Box, Hidden, Toolbar, Typography } from "@mui/material";
import React from "react";
import { LOCALE } from "../../properties/Locale";
import { useTheme } from "@emotion/react";

export default function Header() {
  const theme = useTheme();

  return (
    <Toolbar
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "20px",
        position: "relative",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          marginLeft: {
            xs: 0, // no margin on phones
            sm: "130px", // margin on tablets and larger
          },
        }}
      >
        <Hidden smDown>
          <img
            id="login-landing-edsr-logo"
            src={`${process.env.PUBLIC_URL}/assets/mt-logo-gold.png`}
            alt="RM"
            width="60px"
          />
        </Hidden>

        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Typography
            variant="subtitle2"
            style={{
              fontFamily: "Inter-Light",
              lineHeight: "0.8",
              color: theme.palette.secondary.main,
              marginTop: "2px",
              textTransform: "uppercase",
            }}
          >
            Министерство за транспорт
          </Typography>
          <Typography
            variant="subtitle1"
            sx={{
              fontFamily: "Inter-Medium",
              lineHeight: "1.1",
              fontWeight: "500",
              color: "black",
              mt: 0.3,
              width: {
                xs: "250px",
                sm: "400px",
              },
              wordBreak: "break-word",
            }}
          >
            {LOCALE.systemName}
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          position: "absolute",
          right: 0,
          top: 0,
          height: "100%",
          width: "830px",
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "center",
          "&::after": {
            content: '""',
            position: "absolute",
            left: 0,
            top: 0,
            width: "100%",
            height: "100%",
            background:
              "linear-gradient(to right, rgba(255,255,255,1), rgba(255,255,255,0))",
            zIndex: 1,
          },
        }}
      >
        {Array.from({ length: 10 }).map((_, i) => (
          <Box
            key={i}
            sx={{
              width: "83px",
              height: "100%",
              background: `linear-gradient(135deg, #f1a32ea8 50%, transparent 0), linear-gradient(-135deg, #3b7de780 50%, transparent 0)`,
              opacity: 0.3,
            }}
          />
        ))}
      </Box>
    </Toolbar>
  );
}
